module.exports = __webpack_public_path__ + "static/BK_MAINSHOW_PROMO_BREAK_4-153ca1aa4ecf9acf3f3438fc61062be5.mp4";